const config = {
    "title": "Aviation Week",
    "appKey": "58ac7be8-74e4-4ff9-aada-1e3976be6816",
    "stripeKey": "pk_test_W955SArBKQSl0oJiqvTy1RpK002fHGREqC",
    "host": "https://graphql.canvasflow.io",
    "theme": {
        "toc": {
            "background": "#f8f8f8",
            "color": "#000000",
            "selectedColor": "#000000",
            "textTransform": "none",
            "listStyle": "none"
        },
        "color": "#ffffff",
        "background": "#ffffff",
        "loading": {
            "color": "#062c6b",
            "type": false
        },
        "progressBar": {
            "background": "#ffffff",
            "color": "#4d85ba",
            "enabled": true,
            "height": 5
        },
        "navbar": {
            "background": "#ffffff",
            "color": "#0d2c6b",
            "slider": {
                "background": "#ededed",
                "accentColor": "#b9b9b9",
                "color": "#b9b9b9",
                "knob": {
                    "size": 25,
                    "color": "#4d85ba"
                }
            },
            "toc": {
                "color": "#ff9900",
                "selectedColor": "#ff9900",
                "textTransform": "none",
                "listStyle": "none"
            }
        },
        "buttons": {
            "primary": {
                "color": "#ffffff",
                "background": "#0d2c6b"
            },
            "secondary": {
                "color": "#ffffff",
                "background": "#4d85ba"
            }
        },
        "ribbons": {
            "display": false
        },
        "issues": {
            "title": {
                "display": true
            }
        },
        "bottomBar": {
            "background": "#0d2c6b",
            "accentColor": "#4d85bc",
            "color": "#ffffff",
            "slider": {
                "background": "#555555",
                "accentColor": "#4d85ba",
                "color": "#555555",
                "knob": {
                    "size": 25,
                    "color": "#4d85ba"
                }
            }
        }
    },
    "version": "1.13.5",
    "auth": {
        "google": true,
        "apple": true,
        "email": true
    },
    "password": {
        "enabled": false,
        "value": ""
    },
    "rssFeed": {
        "enabled": false
    },
    "search": {
        "enabled": false
    },
    "lastLocation": {
        "enabled": false
    },
    "tts": {
        "enabled": true
    },
    "admin": {
        "enabled": true
    },
    "iframe": {
        "enabled": false
    },
    "bookmarks": {
        "enabled": true
    },
    "readTime": {
        "enabled": false
    },
    "indexing": {
        "enabled": false
    }
};
window.appKey = '58ac7be8-74e4-4ff9-aada-1e3976be6816';
window.version = '1.13.5';
window.config = config;
export default config;